//@ts-nocheck
import { Box, Paper, Typography, Tooltip, Skeleton } from "@mui/material";
import { numberFormatter } from "../../../../../../../utility/numberFormatter";
import { calculatePercentageDifference } from "../utils";
type Props = {
  title?: string;
  value: number;
  priorValue: number;
  description?: string;
  formatter?: (value: number) => string;
  inverse?: boolean;
  loading?: boolean;
  valueProps?: {
    [key: string]: any;
  };
};
export const Metric = ({
  title,
  value = 0,
  priorValue = 0,
  description,
  formatter,
  inverse,
  loading = false,
  valueProps
}: Props) => {
  return <Tooltip title={!loading && description ? <TooltipBody title={title} value={formatter ? formatter(value) : value?.toLocaleString()} description={description} /> : ""} followCursor components={{
    Tooltip: Box
  }} data-sentry-element="Tooltip" data-sentry-component="Metric" data-sentry-source-file="Metric.tsx">
      <Box width="100%" data-sentry-element="Box" data-sentry-source-file="Metric.tsx">
        {!title ? null : loading ? <Skeleton variant="rectangular" width="80%" height={18} sx={{
        bgcolor: "grey.200"
      }} /> : <Typography variant="body3" color="text.secondary" fontWeight={600}>
            {title}
          </Typography>}
        {loading ? <Skeleton variant="rectangular" width="100%" height={32} /> : <Typography variant="h4" fontWeight={600} sx={{
        mb: 0.5,
        ...valueProps
      }}>
            {formatter ? formatter(value) : numberFormatter.format(value)}
          </Typography>}
        {loading ? <Skeleton variant="rectangular" width="100%" height={18} sx={{
        mt: 1
      }} /> : <Typography variant="body3" color="text.disabled">
            {formatter ? formatter(priorValue) : numberFormatter.format(priorValue)}{" "}
            <Typography variant="body3" color={calculatePercentageDifference(priorValue, value).startsWith("-") ? inverse ? "success.main" : "error.main" : inverse ? "error.main" : "success.main"}>
              {calculatePercentageDifference(priorValue, value)}
            </Typography>
          </Typography>}
      </Box>
    </Tooltip>;
};
const TooltipBody = ({
  title,
  value,
  description
}: any) => {
  return <Paper sx={{
    width: 200,
    p: 2
  }} data-sentry-element="Paper" data-sentry-component="TooltipBody" data-sentry-source-file="Metric.tsx">
      <Typography variant="body3" fontWeight={600} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="Metric.tsx">
        {title}
      </Typography>
      <Typography variant="h4" fontWeight={600} sx={{
      mt: 0.25
    }} data-sentry-element="Typography" data-sentry-source-file="Metric.tsx">
        {value}
      </Typography>
      <Typography fontWeight={500} color="text.secondary" sx={{
      mt: 1,
      fontSize: "10px",
      lineHeight: "14px"
    }} data-sentry-element="Typography" data-sentry-source-file="Metric.tsx">
        {description}
      </Typography>
    </Paper>;
};